<script>
  import { fade } from "svelte/transition"
</script>

<svelte:head>
  <title>Cookie Policy | Hollas AB</title>
  <meta
    name="description"
    content="Hollas AB Cookie Policy - How we use cookies on our website"
  />
</svelte:head>

<div class="max-w-4xl mx-auto px-4 py-16" in:fade={{ duration: 300 }}>
  <h1 class="text-3xl md:text-4xl font-bold mb-8 text-white">Cookie Policy</h1>

  <div class="prose prose-lg prose-invert max-w-none">
    <p class="text-slate-300">
      Last updated: {new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })}
    </p>

    <h2>What are cookies?</h2>
    <p>
      Cookies are small text files that are placed on your device when you visit
      a website. They are widely used to make websites work more efficiently,
      provide a better user experience, and to provide information to the owners
      of the site.
    </p>

    <h2>How we use cookies</h2>
    <p>We use cookies for the following purposes:</p>
    <ul>
      <li>
        <strong>Necessary cookies:</strong> These cookies are essential for the website
        to function properly. They enable core functionality such as security, network
        management, and accessibility.
      </li>
      <li>
        <strong>Analytics cookies:</strong> These cookies help us understand how
        visitors interact with our website by collecting and reporting information
        anonymously.
      </li>
      <li>
        <strong>Functional cookies:</strong> These cookies enable the website to
        provide enhanced functionality and personalization.
      </li>
    </ul>

    <h2>Types of cookies we use</h2>
    <table class="border-collapse w-full my-6">
      <thead>
        <tr class="bg-slate-800">
          <th class="border border-slate-700 p-2 text-left">Cookie Name</th>
          <th class="border border-slate-700 p-2 text-left">Purpose</th>
          <th class="border border-slate-700 p-2 text-left">Duration</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="border border-slate-700 p-2">sb-session</td>
          <td class="border border-slate-700 p-2"
            >Authentication cookie for Supabase</td
          >
          <td class="border border-slate-700 p-2">Session</td>
        </tr>
        <tr>
          <td class="border border-slate-700 p-2">_ga</td>
          <td class="border border-slate-700 p-2"
            >Used by Google Analytics to distinguish users</td
          >
          <td class="border border-slate-700 p-2">2 years</td>
        </tr>
        <tr>
          <td class="border border-slate-700 p-2">_gid</td>
          <td class="border border-slate-700 p-2"
            >Used by Google Analytics to distinguish users</td
          >
          <td class="border border-slate-700 p-2">24 hours</td>
        </tr>
      </tbody>
    </table>

    <h2>Managing cookies</h2>
    <p>
      Most web browsers allow control over cookies through the browser settings.
      You can set your browser to refuse all or some browser cookies, or to
      alert you when websites set or access cookies. If you disable or refuse
      cookies, please note that some parts of this website may become
      inaccessible or not function properly.
    </p>
    <p>
      To find out more about cookies, including how to see what cookies have
      been set and how to manage and delete them, visit <a
        href="https://www.aboutcookies.org"
        target="_blank"
        rel="noopener noreferrer"
        class="text-blue-400 hover:text-blue-300">www.aboutcookies.org</a
      >
      or
      <a
        href="https://www.allaboutcookies.org"
        target="_blank"
        rel="noopener noreferrer"
        class="text-blue-400 hover:text-blue-300">www.allaboutcookies.org</a
      >.
    </p>

    <h2>Changes to our cookie policy</h2>
    <p>
      We may update our cookie policy from time to time. Any changes will be
      posted on this page with an updated revision date.
    </p>

    <h2>Contact us</h2>
    <p>
      If you have any questions about this cookie policy, please contact us at
      info@hollas.net.
    </p>
  </div>
</div>

<style>
  /* Styling for the policy page */
  :global(.prose) {
    color: #e2e8f0;
  }

  :global(.prose h2) {
    color: #f8fafc;
    font-size: 1.5rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  :global(.prose p) {
    margin-bottom: 1.25rem;
  }

  :global(.prose ul) {
    margin-bottom: 1.5rem;
  }

  :global(.prose li) {
    margin-bottom: 0.5rem;
  }

  :global(.prose strong) {
    color: #f1f5f9;
  }

  :global(.prose a) {
    color: #38bdf8;
    text-decoration: none;
  }

  :global(.prose a:hover) {
    color: #7dd3fc;
    text-decoration: underline;
  }
</style>
